/**
 * Central widget defaults. Previously `KXPRESNOMD-28` and the default
 * dimensions were hardcoded across SymbolDetail/Watchlist/AdvancedChart; they
 * now live here once. The embed loader (public/js/kalshi-embed-event.js) and the
 * server routes keep their own last-resort fallbacks, but the config UI sources
 * its defaults from this file so changing them is a one-line edit.
 */

export const DEFAULT_EVENT_TICKER = 'KXPRESNOMD-28';
export const DEFAULT_WIDTH = '100%';
export const DEFAULT_HEIGHT = '100%';
export const DEFAULT_PERIOD = 'all';
export const DEFAULT_THEME: 'light' | 'dark' = 'light';

/** UTM medium is always 'widget' for embeds (matches the legacy EmbedCodePlain output). */
export const WIDGET_UTM_MEDIUM = 'widget';
